import request from "./request";
import { IRequest } from "@/shared/types/request";
import { IVariant } from "@/shared/types/variants";

export const createVariant = (field: IVariant) =>
  request.post<never, IRequest<IVariant>>(`/variants`, field);
